/**
 * Instagram swipe feed — local theme thumbs (no expired IG CDN).
 */
(() => {
  const doc = document;

  const cleanHandle = (h) =>
    String(h || '')
      .trim()
      .replace(/^@/, '')
      .replace(/^https?:\/\/(www\.)?instagram\.com\//i, '')
      .split(/[/?#]/)[0]
      .toLowerCase();

  const assetBase = () => {
    const script = doc.querySelector('script[src*="instagram-feed"]');
    return script?.src ? script.src.replace(/instagram-feed\.js.*$/, '') : '/cdn/shop/t/4/assets/';
  };

  const cacheUrl = () => {
    const script = doc.querySelector('script[src*="instagram-feed"]');
    const v = (script?.src || '').match(/[?&]v=([^&]+)/);
    const bust = v ? v[1] : String(Date.now());
    return `${assetBase()}ig-cache.json?v=${bust}`;
  };

  const resolveThumb = (url) => {
    if (!url) return url;
    if (!/^https?:\/\//i.test(url)) return `${assetBase()}${url.replace(/^\//, '')}`;
    return url; // already absolute shopify asset
  };

  const buildCard = (item, handle) => {
    const a = doc.createElement('a');
    a.className = 'mw-ig__post';
    a.href = item.permalink || `https://www.instagram.com/${handle}/`;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';

    const img = doc.createElement('img');
    img.className = 'mw-ig__img';
    img.src = resolveThumb(item.thumb);
    img.alt = item.caption || handle;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 360;
    img.height = 450;
    a.appendChild(img);

    if (item.isVideo) {
      const badge = doc.createElement('span');
      badge.className = 'mw-ig__badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
      a.appendChild(badge);
    }
    return a;
  };

  const renderItems = (rail, items, handle, hint) => {
    const frag = doc.createDocumentFragment();
    items.forEach((item) => frag.appendChild(buildCard(item, handle)));
    rail.appendChild(frag);
    if (hint) { hint.hidden = true; hint.remove(); }
  };

  const loadCache = async (handle) => {
    const res = await fetch(cacheUrl(), { credentials: 'same-origin', cache: 'no-cache' });
    if (!res.ok) throw new Error('no_cache');
    const data = await res.json();
    if (cleanHandle(data.handle) !== handle) throw new Error('handle_mismatch');
    if (!Array.isArray(data.items) || !data.items.length) throw new Error('empty_cache');
    return data.items;
  };

  const wireNav = (section) => {
    const rail = section.querySelector('[data-ig-rail]');
    if (!rail || section.dataset.igNav) return;
    section.dataset.igNav = '1';
    const step = () => Math.max(160, Math.floor(rail.clientWidth * 0.7));
    section.querySelector('[data-ig-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    section.querySelector('[data-ig-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
  };

  const initSection = async (section) => {
    wireNav(section);
    const handle = cleanHandle(section.getAttribute('data-ig-handle'));
    const rail = section.querySelector('[data-ig-rail]');
    const hint = section.querySelector('[data-ig-hint]');
    if (!handle || !rail) return;
    if (rail.querySelectorAll('.mw-ig__post').length > 0) {
      if (hint) { hint.hidden = true; hint.remove(); }
      return;
    }
    try {
      const items = await loadCache(handle);
      renderItems(rail, items, handle, hint);
    } catch (e) {
      if (hint) {
        hint.innerHTML =
          'Follow <a href="https://www.instagram.com/' +
          handle +
          '/" target="_blank" rel="noopener">@' +
          handle +
          '</a> for latest drops';
      }
    }
  };

  const boot = () => {
    doc.querySelectorAll('[data-ig-section]').forEach((el) => {
      if (el.dataset.igReady) return;
      el.dataset.igReady = '1';
      initSection(el);
    });
  };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
